import React, { useContext, useEffect, useState } from 'react';
import { CotizadorCRDataContext } from '../../context/CotizadorCRDataContext';
import { estadoCivil } from '../../data/mochaData';
import useToken from '../../hooks/useToken';
import { ImgNext } from '../../svg';
import Container from '../Container';
import ControlButton from '../controls/ControlButton';
import Pages from './Pages';

const TempContainer = ({ ...rest }) => {
    const { loading } = useToken();

    const [index, setIndex] = useState(2);

    const { poliza }  = useContext(CotizadorCRDataContext);

    const paginaConyuge=3;

    useEffect(() => {

        if (!loading) {

            setTimeout(() => {
                const preloader = document.querySelector('.site-preloader');

                if (preloader) {
                    preloader.addEventListener('transitionend', (event) => {
                        if (event.propertyName === 'opacity') {
                            preloader.parentNode.removeChild(preloader);
                        }
                    });
                    preloader.classList.add('site-preloader__fade');
                }
            }, 600);

        }

    }, [loading]);

    const pages = 10;

    const textNext = index === pages ? 'Finalizar' : 'Siguiente';

    const decrement = () => {
        let i = index - 1;

        //si es casado saltar pagina
        if (poliza.estadoCivil != '1' && i == paginaConyuge)
            i--;

        if (index !== 0)
            setIndex(i);
        else
            back();
    };

    const increment = disabled => {
        let i = index + 1;

        //si es casado saltar pagina
        if (poliza.estadoCivil != '1' && i == paginaConyuge)
            i++;
        if (index !== pages) {
            setIndex(i);
        }

    }

    const back = () => {
        rest.history.push('/', { data: null });
    }


    const handleSubmit = async (e) => {
        increment(true);
        return;
        let result = document.querySelector('form').reportValidity();

        //console.log(index);

        if (result /*&& validateSelects()*/) {

            // await execute(index);

            // result = validateQuestions(index);
            // if (result)
            increment(true);
        }
    }

    return (

        <Container>

            <div className="layoutcr">
                <div className="header-section">
                    <h2 className="txt-esmeralda txt-light text-center"></h2>
                    <h3 className="txt-light text-center" style={{ paddingLeft: '22px', paddingRight: '22px' }}>Con su póliza de Automóvil LAFISE Plus<br /> disfrute cada momento sin preocupaciones</h3>
                </div>

                <form className="d-grid">
                    <Pages indexProgress={index} />
                    <ControlButton>

                        <button className={`control-button-btn prev`}
                            type="button"
                            onClick={decrement} style={{ visibility: index != 0 ? 'visible' : 'hidden' }} >Regresar</button>



                        {index < pages &&
                            <button className="control-button-btn next"
                                type="button"
                                onClick={handleSubmit}>
                                {textNext}
                                {index !== pages && <ImgNext />}
                            </button>
                        }
                    </ControlButton>

                </form>
            </div>

        </Container>

    );
}

export default TempContainer;
